module.exports = __webpack_public_path__ + "static/media/brick-down.c8cd969f.jpg";